// extracted by mini-css-extract-plugin
export default {"button":"Button_button__As++W","gray":"Button_gray__KPV9Z","red":"Button_red__P1eW4"};